import React from 'react';
import { Heart } from 'lucide-react';

export default function FavoriteButton({ active, onClick, size = 'md', className = '', testid }) {
  const cls = size === 'sm' ? 'w-7 h-7' : 'w-9 h-9';
  const ic = size === 'sm' ? 'w-3.5 h-3.5' : 'w-4 h-4';
  return (
    <button
      type="button"
      aria-label={active ? 'Remove from favorites' : 'Save to favorites'}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); onClick && onClick(e); }}
      className={`${cls} rounded-full flex items-center justify-center puvio-focus transition-all border ${active ? 'bg-[#FFE6E6] border-[#FFB3B3]' : 'bg-white/90 border-black/10 hover:bg-[#FFF5F5]'} ${className}`}
      data-testid={testid || 'fav-button'}
    >
      <Heart className={`${ic} ${active ? 'text-[#FF4D4F] fill-[#FF4D4F]' : 'text-[#0F1A13]'}`} />
    </button>
  );
}
